var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("tr", [
    _c("td", [
      _c(
        "button",
        {
          staticClass: "text-black font-sans-bold underline text-left",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.showEventDetail.apply(null, arguments)
            },
          },
        },
        [_vm._v("\n            " + _vm._s(_vm.event.title) + "\n        ")]
      ),
    ]),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm.event.festival.title))]),
    _vm._v(" "),
    _vm.isCurrentEvent
      ? _c("td", [
          _vm._v(
            _vm._s(_vm.event.user.fullName) +
              ", " +
              _vm._s(_vm.event.organization.name)
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm._f("dateFormat")(_vm.event.created_at)))]),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm._f("dateFormat")(_vm.event.start_at)))]),
    _vm._v(" "),
    _vm.published
      ? _c("td", [_vm._v("Published")])
      : _c(
          "td",
          [
            _vm.status == "new" ? [_vm._v("Draft")] : _vm._e(),
            _vm._v(" "),
            _vm.status == "needs review" ? [_vm._v("In Review")] : _vm._e(),
          ],
          2
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }